/**
 * Platform detection helpers.
 *
 * Use these throughout shared pages to branch on desktop vs web without
 * cluttering components with navigator.userAgent checks.
 */

export function isDesktop() {
  return typeof window !== 'undefined'
    && (window.location.protocol === 'pdfsuite:'
        || !!window.electronAPI?.isDesktop);
}

export function isWeb() {
  return !isDesktop();
}
